import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/open-sans/400.css';

import * as ReactDOM from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container as HTMLElement);

root.render(<App />);
